import {
  Box,
  Button,
  Checkbox,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import React, { useState, useCallback } from "react";
import { useSnackbar } from "notistack";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { isValidTimeRange } from "../../../../utils/constants/TimeHourValidation";
import dayjs from "dayjs";
import MotionWrapper from "../../../../components/MotionWrapper";
import useResponsive from "../../../../Hooks/useResponsive";

const SetCommonTime = React.memo(({ preferences, setPreferences }) => {
  const smUp = useResponsive("up", "sm");

  const mdUp = useResponsive("up", "md");
  const { enqueueSnackbar } = useSnackbar();
  const [view, setView] = useState(false);
  const [time, setTime] = useState({
    startTime: null,
    endTime: null,
  });

  const updatePreferredDayTime = useCallback(
    (newFromTime, newToTime) => {
      const updatedDayTime = preferences?.map((item) => ({
        ...item,
        startTime: newFromTime,
        endTime: newToTime,
      }));
      setPreferences(updatedDayTime);
    },
    [preferences, setPreferences]
  );

  const handleSet = useCallback(() => {
    const { startTime, endTime } = time;

    if (!startTime || !endTime) {
      enqueueSnackbar("Please select time", { variant: "error" });
      return;
    }

    if (isValidTimeRange(startTime, endTime)) {
      updatePreferredDayTime(startTime, endTime);
      enqueueSnackbar("Time Added successfully", { variant: "success" });
    } else {
      enqueueSnackbar("Time difference must be 1 hour", { variant: "error" });
    }
  }, [time, updatePreferredDayTime, enqueueSnackbar]);

  const handleChange = useCallback((event) => {
    setView(event.target.checked);
  }, []);

  const handleTimeChange = useCallback(
    (key) => (newValue) => {
      if (!newValue || dayjs(newValue).isSame(time[key])) return;
      setTime((prev) => ({ ...prev, [key]: newValue }));
    },
    [time]
  );

  return (
    <Box>
      <Stack direction="row" spacing={1}>
        <Typography variant="h6" sx={{ pt: 0.7 }}>
          Want to add common time for all..?
        </Typography>
        <Checkbox
          checked={view}
          onChange={handleChange}
          inputProps={{ "aria-label": "controlled" }}
        />
      </Stack>

      {view && (
        <MotionWrapper delay={0.5} directions="top">
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Stack direction={!smUp ? "column" : "row"} spacing={1}>
              <Box sx={{ width: "100%" }}>
                <TimePicker
                  label="Start Time"
                  value={time.startTime}
                  onChange={handleTimeChange("startTime")}
                  renderInput={(params) => <TextField {...params} />}
                />
              </Box>
              <Box sx={{ width: "100%" }}>
                <TimePicker
                  label="End Time"
                  value={time.endTime}
                  onChange={handleTimeChange("endTime")}
                  renderInput={(params) => <TextField {...params} />}
                />
              </Box>
              <Button onClick={handleSet}>Set</Button>
            </Stack>
          </LocalizationProvider>
        </MotionWrapper>
      )}
    </Box>
  );
});

export default SetCommonTime;
